import * as LoginActions from './loginActions'
import * as ApplicationActions from './applicationActions'
import * as URLActions from './urlactions'
import * as UserActions from './userActions'
export const ActionCreators = Object.assign({},
   LoginActions,
   ApplicationActions,
   URLActions,
   UserActions
  )